module.exports = __webpack_public_path__ + "img/Cambodia.7c2e7abd.png";